<template>
	<el-footer class="admin-footer" height="50px" @mouseover="stop" @mouseout="show" style="padding-left: 260px">
		<el-carousel ref="banner" style="width: 100%" height="50px" direction="vertical" :autoplay="true" arrow="never"
			:interval="3000" indicator-position="none">
			<el-carousel-item v-for="(item, index) in items" :key="index">
				<div class="warningInfo" @click="goMenuUrl">
					<div class="warningInfoDetail" style="width: 400px">
						报警时间：{{ item.startTime }}
					</div>
					<div class="warningInfoDetail" style="width: 600px">
						报警地址：{{ item.address }}
					</div>
					<div class="warningInfoDetail" style="width: 300px">
						探头地址: {{ item.probeAddress }}
					</div>
					<div class="warningInfoDetail" style="width: 300px">
						报警设备：{{ item.deviceCode }}
					</div>
					<div class="warningInfoDetail" style="width: 400px">
						报警内容：{{ item.content }}
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>
	</el-footer>
</template>

<script>
	import Alarm from "@/assets/js/alarm/alarm.js";
	export default {
		name: "AdminFooter",
		data() {
			return {
				language: "",
				items: [],
				msg: "",
				timer: null,
				gamemuiscs1: null,
			};
		},
		mounted() {
			this.gamemuiscs1 = new Audio(
				"https://www.sfrsafety.com/static/img/warn.wav"
			);
			let startTime = this.getDay();
			let param = {
				startTime: startTime,
				startTime2: startTime,
				pageNo: 1,
				pageSize: 10,
				state: [0, 4],
				source: [0, 1],
				error: [0, 1, 2, 3, 4, 5, 6],
				workOrderState: [0, 4],
			};
			let that = this;
			setTimeout(function() {
				that.getItems(param);
			}, 1000);
			setInterval(() => {
				that.getItems(param);
			}, 12000);
		},
		methods: {
			muiscPlay1(index) {
				// this.gamemuiscs1 = new Audio(
				// 	"https://www.sfrsafety.com/static/img/warn.wav"
				// );
				if (index == 1) {
					this.gamemuiscs1.play();
				} else {
					this.gamemuiscs1.pause();
				}
			},
			getDay() {
				var time = new Date().getTime();
				var yesterday = new Date(time);
				var month = yesterday.getMonth();
				var day = yesterday.getDate();
				yesterday =
					yesterday.getFullYear() +
					"-" +
					(yesterday.getMonth() > 9 ?
						yesterday.getMonth() + 1 :
						"0" + (yesterday.getMonth() + 1)) +
					"-" +
					(yesterday.getDate() > 9 ?
						yesterday.getDate() :
						"0" + yesterday.getDate());
				return yesterday;
			},
			goMenuUrl() { // 全局报警点击事件
				/*var trueUrl = '';
				  if (this.$store.getters.getLevelType == 1) {
				    trueUrl = '/static/productLine/alarmList/companyAlarm.html'
				  } else {
				    trueUrl = '/static/productLine/alarmList/deviceAlarm.html'
				  }
				  this.$router.push({
				    path: trueUrl
				  });*/
			},
			show() {
				if (this.timer != null) return;
				this.timer = setInterval(() => {
					let start = this.msg.substring(0, 1); //获取到头的第一个字符
					let end = this.msg.substring(1); //获取到后面的所有字符
					this.msg = end + start; //重新拼接得到新的字符串，并赋值给this.message
				}, 100);
			},
			stop() {
				clearInterval(this.timer);
				this.timer = null; //清除定时器之后，需要重新将定时器置为null
			},
			getItems(param) {
				param.state = [0];
				Alarm.getExcel(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.items = data.data;
						if (data.data != "") {
							this.muiscPlay1(1);
						} else {
							this.muiscPlay1(2);
						}
					}
				});
			},
			goUrl() {
				clearInterval(sessionStorage.getItem("gearLineInterval"));
				clearInterval(this.$store.getters.getCrontab);
				this.$router.push("/static/equipmentMgt/malfunctionList.html");
			},
		},
	};
</script>
<style>
	.admin-footer {
		position: absolute;
		bottom: 0;
		width: 100%;
		padding-left: 230px;
		z-index: 99;
		display: flex;
		align-items: center;
		background: #000000;
	}

	.bottom-text {
		font-size: 12px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #222223;
	}

	.bottom-text a {
		margin-left: 5px;
		color: #222223;
		text-decoration: none;
	}

	.warningInfo {
		padding-left: 20px;
		display: flex;
		height: 50px;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}

	.warningInfoDetail {
		font-size: 18px;
		color: #ff0000;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue